<template>
  <div class="img-template-dialog" @click.stop v-if="dialogVisiable">
    <div class="itd-bg">
      <div class="itd-container">
        <div class="itd-header">更换素材前，请先选择拼图类型 <i class="el-icon-close itd-close" @click="onCancel"/></div>
        <div class="itd-body" @click="onImgClick">
          <template v-if="dataList && dataList.length > 0">
            <ul class="itd-group" @click.stop>
              <li v-for="(item, index) in dataList" :key="index"
                  :class="{'selected': currentGroupIndex === index}" @click="onSelect(item, index)">
                <p class="gl-img-box">
                  <img-template :data="item" :size="{width: 50, height:50}"></img-template>
                  <span class="gl-cover"></span>
                </p>
                <p class="gl-img-name">{{item.name}}</p>
              </li>
            </ul>
            <template v-if="groupItem.name ">
              <div class="group-content">
                <img-template :key="currentGroupIndex" ref="imgTemplateRef"
                              @onDragStop="onDragStop"
                              @onAddNewImg="onAddNewImg"
                              :data="groupItem"
                              :size="{width: 300, height: 340}"
                              :draggableResize="true"></img-template>
              </div>
            </template>
          </template>
        </div>
        <div class="itd-footer">
          <el-button class="el-button-custom" type="primary" @click="onConfirm" :loading="btnLoading"
                     v-if="dataList.length > 0">完成
          </el-button>
          <el-button class="el-button-custom" @click="onCancel">取消</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import imgTemplate from './index';
    import Util from '../../../util'
    // import uploader from '../../template/img-template/uploader'
    export default {
        components: {imgTemplate},
        props: {
            data: {
                type: Array,
                default() {
                    return [];
                }
            },
        },
        data() {
            return {
                screenshotRender: false,
                btnLoading: false,
                disabledTip: false,
                tipVisiable: true,
                currentGroupIndex: 0,
                dataList: []
            }
        },
        computed: {
            groupItem() {
                return this.$store.state.group.groupItem;
            },
            materialUrl() {
                return this.$store.state.group.materialUrl;
            },
            dialogVisiable() {
                return this.$store.state.group.dialogVisiable
            },
            initIndex() {
                return this.$store.state.group.activeGroupIndex
            }
        },
        watch: {
            dialogVisiable(v) {
                if (!v) {
                    this.disabledTip = false;
                    this.tipVisiable = true;
                } else {
                    this.dataList = JSON.parse(JSON.stringify(this.data || []));
                    if (this.dataList.length > 0) {
                        if (this.initIndex !== null && this.initIndex !== undefined && this.initIndex > -1) {
                            this.currentGroupIndex = this.initIndex;
                        } else {
                            this.currentGroupIndex = 0;
                        }
                        this.$store.commit('group/set_group', this.dataList[this.currentGroupIndex]);
                    }
                }
            }
        },
        mounted() {
        },
        methods: {
            menuImgStyle(item) {
                let scale = Util.getScaleWidthAndHeight(50, 50, item.json.width, item.json.height);
                return `transform: scale(${scale})`
            },
            onConfirm() {
                this.btnLoading = true;
                Util.html2ImgUrl(this.$refs.imgTemplateRef.$el).then((url) => {
                    this.$emit('completed', this.groupItem, url);
                    setTimeout(() => {
                        this.btnLoading = false;
                        this.$store.commit('group/toggle_dialog', false);
                    }, 200);
                }).catch(() => {
                    this.btnLoading = false;
                })
            },
            onCancel() {
                this.$store.commit('group/toggle_dialog', false);
            },
            onImgClick() {
                // if (this.dataList && this.dataList.length > 0) {
                //   this.disabledTip = true;
                //   this.$store.commit('group/next_select');
                //   this.$emit('clickImg')
                // }
            },
            onSelect(item, index) {
                this.$store.commit('group/set_select', 0);
                this.$store.commit('group/set_group', item);
                this.currentGroupIndex = index;
            },
            onUploadCompleted(data) {
                this.dataList = data;
                this.$store.commit('group/set_group', data[0]);
            },
            onDragStop(idx, left, top, width, height) {
                let dataList = this.dataList[this.currentGroupIndex].json.data;
                let item = dataList[idx];
                item.left = left;
                item.top = top;
                if (width) {
                    item.width = width;
                }
                if (height) {
                    item.height = height;
                }
            },
            onAddNewImg(obj) {
            }
        }
    }
</script>
<style lang="scss">
  @import "./dialog";
</style>